import { useMutation } from '@tanstack/react-query';
import { flatten, path } from 'ramda';
import { catchAndNotify, showNotification } from '@/src/handlers';
import { useHttpClient } from '@invent/platform-api';
import { isSaasBff } from '@/src/api/helpers';
import { clientToServerDashboard } from './data-converters';
import { saveDashboard } from './api';
import { getPortalSettingsFx } from '../widgets/effects';
import { useHistory } from 'react-router-dom';
import { murmur3 } from 'murmurhash-js';

const traceId = '02d0f088-7f60-494a-a981-9c58a7e7144e';

interface IUseDashboardsPostMutation {
  onSuccess?: any;
  onError?: any;
}

export const useDashboardsPostMutation = (options?: IUseDashboardsPostMutation) => {
  const httpClient = useHttpClient();
  const history = useHistory();

  return useMutation({
    mutationFn(dashboardData: IDashboard) {
      return saveDashboard(clientToServerDashboard(dashboardData), httpClient);
    },
    async onSuccess(data, variables, context) {
      if (isSaasBff()) {
        await getPortalSettingsFx();
      }

      const contextualDashboardParams =
        path(['result', 'meta', 'ctxAttributes'], data) ||
        path(['result', 0, 'meta', 'ctxAttributes'], data);
      const searchParams = new URLSearchParams('');

      if (Array.isArray(contextualDashboardParams) && contextualDashboardParams.length > 0) {
        const paramsSorted = flatten(contextualDashboardParams)
          .map((v) => v?.toLowerCase())
          .sort();
        const board_ctx = murmur3(JSON.stringify(paramsSorted));
        searchParams.set('x-db-ctx', String(board_ctx));
      }

      // TODO: Check data
      options?.onSuccess(data, variables, context);

      if (isSaasBff()) {
        history.push(`/${data.url}/compose?${searchParams.toString()}`);
      } else {
        // @ts-expect-error
        history.push(`/dashboard/${data.result.meta.id}/compose`);
      }
    },
    onError(error: any, variables, context) {
      const errorParsed = JSON.parse(error.message);
      const err = isSaasBff()
        ? new Error(JSON.stringify({ ...errorParsed, body: { message: errorParsed.body } }))
        : error;

      catchAndNotify({ message: err, traceId: `${traceId}--2` });
      showNotification('error', errorParsed.body?.message || errorParsed.body);

      options?.onError(err, variables, context);
    }
  });
};
